import { Column, Entity, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { InformationCategory } from '@nsk-app/models/informationCategory';
import { InformationPageImage } from '@nsk-app/models/informationPageImage';
import { ContactInformation } from '@nsk-app/models/contactInformation';

@Entity({
  orderBy: {
    order: 'ASC'
  }
})
export class InformationPage extends OrderedModel {

  @Column()
  title: string;

  @Column()
  visible: boolean;

  @Column()
  text: string;

  @Column({nullable: true})
  contact_id?: number | null;

  @Column()
  information_category_id: number;

  @Column({nullable: true})
  parent_id: number | null;

  @ManyToOne(type => InformationPage, page => page.children)
  @JoinColumn({name: 'parent_id'})
  parent?: Promise<InformationPage>;

  @OneToMany(type => InformationPage, page => page.parent)
  children?: InformationPage[];

  @OneToMany(type => InformationPageImage, media => media.page, {eager: true})
  media?: InformationPageImage[];

  @ManyToOne(type => ContactInformation, {eager: true})
  @JoinColumn({name: 'contact_id'})
  contact?: ContactInformation;

  @ManyToOne('InformationCategory', (category: InformationCategory) => category.pages)
  @JoinColumn({name: 'information_category_id'})
  category: InformationCategory;

}
